import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-lg shadow-foreground-950/10 transition-transform hover:-translate-y-1 hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </a>
  );
}